export const GET_PRODUCT_TYPE_REQUEST = "GET_PRODUCT_TYPE_REQUEST"
export const GET_PRODUCT_TYPE_SUCCESS = "GET_PRODUCT_TYPE_SUCCESS"
export const GET_PRODUCT_TYPE_FAILURE = "GET_PRODUCT_TYPE_FAILURE"